export default __webpack_public_path__ + "static/media/planimages_84b.e7e04c6d.png";